import { Component, OnInit,Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { MasterService } from 'src/app/masters/master.service';
import { LoaderService } from 'src/app/common/loader.service';
import * as CommonConstants from '../../utils/common.constants';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { SharedService } from 'src/app/utils/shared.service';
@Component({
  selector: 'app-enclose-file',
  templateUrl: './enclose-file.component.html',
  styleUrls: ['./enclose-file.component.scss']
})
export class EncloseFileComponent implements OnInit {

  @Input() medFileId;
  dischargeDtls=[];
  PARAM_KEY = [CommonConstants.STATUS, CommonConstants.PATIENT_CONDITION, CommonConstants.MED_URGENCY];
  PARAM__CODE_KEY = [CommonConstants.STATUS, CommonConstants.SUBJECTIVE_SIGN, CommonConstants.OBJECTIVE_SIGN];
  SERVICE_KEYS = [CommonConstants.MED_DISCHARGE];
 dischargeForm: FormGroup;
  submitted: boolean;
  masterValues: any;
  sCategory: any;
  status: any;
  sSubCategory: any;
  constructor(private modal: NgbModal,private fb: FormBuilder, private medicalFileService: MedicalFileService, private masterService: MasterService
    , private toastrService: ToastrService, private sharedService: SharedService, private modalService: BsModalService, private loaderService: LoaderService) { 
    this.getDischargeFormGroup();
  }

  ngOnInit() {
    this.loadMaster();
    this.loadDischargeDetails();
  }
  dischargeAddModal(addDischarge) {
    this.dischargeForm.reset();
    this.modal.open(addDischarge, { size: 'lg', container: '.page-content' });
  }
  loadMaster() {
    this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
      if (response && response['result']) {
        this.masterValues = response['result'];
        this.sCategory = this.masterValues.filter(master => master.paramKey === CommonConstants.SERVICE_CATEGORY);
        this.status = this.masterValues.filter(master => master.paramKey === CommonConstants.STATUS);
        this.sSubCategory = this.masterValues.filter(master => master.paramKey === CommonConstants.SERVICE_SUB_CATEGORY);
      }
    });
  }
  loadDischargeDetails(){
    this.medicalFileService.getDetailsByKeys(this.medFileId, this.SERVICE_KEYS).subscribe(response => {
      if(response["code"]=="S0000" && response["result"]){
        let dischargeList=response["result"];
        this.dischargeDtls=dischargeList[CommonConstants.MED_DISCHARGE];
      }
    },
    error => {
      swal.fire("Error", "Error Occured While Fetching Discharge Details", 'error');
    })
  }
  getDischargeFormGroup(){
    this.dischargeForm = this.fb.group({
    'meddiId':[],
    'medfiId':[],
    'hospiId':new FormControl(),
    'meddiBlFittedCompletReport':new FormControl(),
    'meddiBlMessageSendToAdministration':new FormControl(),
    'meddiBlMessageSendToFamily':new FormControl(),
    'prtieId':new FormControl(),
    'meddiBlMessageSendToPayingParty':new FormControl(),
    'meddiDtAddressed':new FormControl(),
    'meddiDtFinalPlanReceivedFrom':new FormControl(),
    'meddiDtFinalPlanReceivedTo':new FormControl(),
    'meddiDtInformed':new FormControl(),
    'meddiDtLeft':new FormControl(),
    'meddiDtReceiveOn':new FormControl(),
    'meddiVaComment':new FormControl(),
    'meddiVaInformedBy':new FormControl(),
    'meddiVaReason':new FormControl(),
    'statuCode':new FormControl()
  })
  }
  
  saveDischarge() {
    this.submitted = true;
    if (this.dischargeForm.invalid) {
      return;
    }
    let jsonData = this.dischargeForm.value;
    jsonData["meddiDtFinalPlanReceivedFrom"]=this.medDischargeControls.meddiDtFinalPlanReceivedFrom.value ? this.sharedService.getDateFormat(this.medDischargeControls.meddiDtFinalPlanReceivedFrom.value) : null;
    jsonData["meddiDtFinalPlanReceivedTo"]=this.medDischargeControls.meddiDtFinalPlanReceivedTo.value ? this.sharedService.getDateFormat(this.medDischargeControls.meddiDtFinalPlanReceivedTo.value) : null;;
    jsonData["meddiDtReceiveOn"]=this.medDischargeControls.meddiDtReceiveOn.value ? this.sharedService.getDateFormat(this.medDischargeControls.meddiDtReceiveOn.value) : null;
    jsonData["meddiDtAddressed"]=this.medDischargeControls.meddiDtAddressed.value ? this.sharedService.getDateFormat(this.medDischargeControls.meddiDtAddressed.value) : null;
    jsonData["meddiDtInformed"]=this.medDischargeControls.meddiDtInformed.value ? this.sharedService.getDateFormat(this.medDischargeControls.meddiDtInformed.value) : null;
    jsonData["meddiDtLeft"]=this.medDischargeControls.meddiDtLeft.value ? this.sharedService.getDateFormat(this.medDischargeControls.meddiDtLeft.value) : null;
    jsonData["medfiId"]=this.medFileId;
    this.loaderService.display(true);
    this.medicalFileService.saveDischarge(jsonData).subscribe(res => {
      this.loaderService.display(false);
      if (res && res["result"]) {
        let response = res["result"];
        swal.fire("Success", res['message'], 'success');
        if(this.dischargeDtls && this.dischargeDtls.length > 0){
          this.dischargeDtls=this.dischargeDtls.filter(discharge => discharge.meddiId !== response.meddiId);
        }
        this.dischargeDtls.push(response);
        this.modal.dismissAll();
      }
    }, error => {
      this.loaderService.display(false);
      swal.fire("Error", "Error Occured While Saving Discharge Details", 'error');
    })
  }
  
  reset(){
    this.dischargeForm.reset();
  }
  get medDischargeControls() { return this.dischargeForm.controls; }
 onDischargeSelect(event,addDischarge){
  this.dischargeForm.reset();
  let discharge = event.data;
  this.dischargeForm.patchValue({});
  Object.keys(discharge).forEach(name => {
    if (discharge[name] && !CommonConstants.AUDITABLE_ENTITY.includes(name)) {
        this.medDischargeControls[name].patchValue(discharge[name]);
    }
  });
  this.modal.open(addDischarge, { size: 'lg', container: '.page-content' });
}
}
